module.exports = __webpack_public_path__ + "facelifting_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_2_after.jpg
// module id = 1051
// module chunks = 0